import React from 'react';
import PropTypes from 'prop-types';

import style from './style.css';

export default class Home extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired
    }).isRequired
  };

  componentDidMount() {
    this.props.router.push('/wizard/reference');
  }

  render() {
    return <header className={style.header}>
      <h1>Welcome to use Mangabey</h1>
    </header>;
  }

}



// WEBPACK FOOTER //
// ./src/views/home/index.js